import React from "react";
export default (function (_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    className: "recorder__toolbar"
  }, children);
});